import { Component, OnInit } from '@angular/core';
import { Supervisor } from '../../entity';
import { HotelService, PaginationService } from '../../service';
import { ISort } from '../../interfaces';


@Component({
    selector: 'app-hotels',
    templateUrl: './hotels.component.html'
})
export class HotelsComponent implements OnInit {
    hotels: Array<Supervisor> = new Array<Supervisor>();
    filteredList: Array<Supervisor>;

    //#region component state properties
    loadingState = false;
    noRecordsState = false;
    //#endregion

    //#region search & sort properties
    tags = new Array<string>();
    searchWord = '';
    sortOptions: ISort[];
    selectedSortOption: ISort;
    reverse = false;
    //#endregion

    //#region pagination properties
    pagedItems: Array<Supervisor>;
    pager: any = {};
    //#endregion

    constructor(
        private hotelService: HotelService,
        private paginationService: PaginationService
    ) { }

    ngOnInit() {
        this.refresh();
        this.sortOptions = sortOptions;
        this.selectedSortOption = sortOptions[0];
    }

    refresh() {
        this.loadingState = true;

        this.hotelService.getAllHotels().subscribe(data => {
            const hotels = new Array<Supervisor>();
            data.forEach(item => {
                const hotel = new Supervisor();
                hotel.fromObject(item);

                if (hotel.Avatar == null) {
                    hotel.Avatar = './../../assets/placeholder.jpg';
                }

                hotels.push(hotel);
            });

            this.hotels = hotels;
            this.loadingState = false;
            this.filteredList = this.paginationService.sortArray(hotels, this.selectedSortOption.objKey, this.reverse);
            this.setPage(1);

            if (this.hotels.length > 0) {
                this.noRecordsState = false;
            } else {
                this.noRecordsState = true;
            }
        }, (err) => {
            this.loadingState = false;
            this.noRecordsState = true;
        });
    }

    //#region pagination, search, sort
    updateFilterTags(tags: Array<string>) {
        this.tags = tags;
        this.refreshFilteredList();
    }

    search(word?: string): void {
        this.searchWord = word;
        this.refreshFilteredList();
    }

    changeSortOption(sortOption: ISort): void {
        this.selectedSortOption = sortOption;
        this.refreshFilteredList();
    }

    toggleReverse(reverse: boolean): void {
        this.reverse = reverse;
        this.refreshFilteredList();
    }

    refreshFilteredList(): void {
        this.filteredList = this.hotels;
        this.filteredList = this.paginationService.filterArray(this.filteredList, 'Location', this.tags);
        this.filteredList = this.paginationService.filterArray(this.filteredList, 'FullName', [this.searchWord]);
        this.filteredList = this.paginationService.sortArray(this.filteredList, this.selectedSortOption.objKey, this.reverse);
        this.setPage(1);
    }

    setPage(page: number): void {
        this.pager = this.paginationService.getPager(this.filteredList.length, page, 6);
        this.pagedItems = this.filteredList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
    //#endregion
}

const sortOptions: ISort[] = [
    { displayName: 'Nume', objKey: 'FullName' },
    { displayName: 'Data adaugare', objKey: 'CreateDate' }
];

